<template>
  <div class="fadein">
    <div class="h30"></div>
    <transition name="el-zoom-in-center">
    <div class="center1200 bg-white">
        <div class="h20"></div>
        <div class="center-title" style="position:relative;">
          <span><img class="title-pic" src="/static/img/title-left.png" alt=""> 编辑文章 <img class="title-pic" src="/static/img/title-right.png" alt=""></span>
          <span  @click="goback" style=" cursor: pointer;position:absolute;left:30px;">返回</span>
        </div>
        <!-- <div class="h20"></div> -->
        <div style="padding:20px;">
          <!-- <el-form-item label="举报的用户为：" :label-width="formLabelWidth"> -->
            标题：<el-input v-model="title" autocomplete="off" placeholder="标题" style="width:1110px;"  ></el-input>
            <div class="h20"></div>
            描述：<el-input v-model="desn" autocomplete="off" placeholder="描述" style="width:1110px;" ></el-input>
          <!-- </el-form-item> -->
            <div class="h20"></div>
            <el-card style="height: 610px;">
              <quill-editor v-model="content" ref="myQuillEditor" style="height: 500px;" :options="editorOption">
              </quill-editor>
            </el-card>
            <div class="h20"></div>
            <div style="text-align:center;">
              <el-button type="primary" style="width:120px;" @click="updateForum()">发 布</el-button>

            </div>
        </div>

    </div>
    </transition>
    <div class="h30"></div>
    <Goback></Goback>

</div>
    
  </template>
  
  <script>
    import {
      quillEditor
    } from 'vue-quill-editor'
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'
    import Goback from '@/components/components/goback'

    export default {
      name: 'FuncFormsEdit',
      components: {
        Goback,
        quillEditor
      },
      data() {
        return {
          //上传的标题
          title:'',
          desn:'',
          //上传的内容
          content: null,
          
          editorOption: {},
          //当前编辑文件的id
          fid:0,
          loading:0,
        }
      },
      watch:{
        //路由改变时执行
        $route(newVal,oldVal){
          if(newVal.name=='editforum'){
              this.fid = this.$route.params.fid
              this.getForum()
              this.openFullScreen()
          }
        },
      },
      mounted(){
        this.fid = this.$route.params.fid
        this.getForum();
        this.openFullScreen()
      },
      methods:{
        //获取文章详情
        getForum(){
          $.ajax({
              url:"//"+ this.$API_URL +"/api/v1/articles/"+this.fid,
              type:"get",
              success:(ret)=>{
                this.title = ret.data.title;
                this.desn = ret.data.desn;
                this.content = ret.data.content
                this.loading = 1
                this.openFullScreen()
              }
          })
        },
        //提交编辑过的文章
        updateForum(){
          if(this.title <=2){
            this.$message({
                showClose:true,
                message:"标题至少2个字呀~  Σ( ° △ °|||)︴ ",
                type:"error"
            })
            return false;
          }
          if(this.desn <=2){
            this.$message({
                showClose:true,
                message:"描述不能为空呀~  Σ( ° △ °|||)︴ ",
                type:"error"
            })
            return false;
          }
          if(this.content == null){
            this.$message({
                showClose:true,
                message:"内容不能为空呀~  Σ( ° △ °|||)︴ ",
                type:"error"
            })
            return false;
          }
          this.loading = 0
          this.openFullScreen();
          $.ajax({
            url:"//"+ this.$API_URL +"/api/v1/articles/"+this.fid,
            type:"POST",
            data:{title:this.title,content:this.content,desn:this.desn,user_id:localStorage.getItem('token'),_method:"PUT",},
            success:(ret)=>{
              // 
              if(ret.code == 201){
                this.$message({
                  showClose:true,
                  message:"文章编辑成功 (*￣∇￣*)",
                  type:"success"
                })
                this.title = ''
                this.content = ''
                // this.$router.push('/forum').catch(err => {err});
                this.goback()
                this.loading = 1
                this.openFullScreen();
              }else{
                this.$message({
                  showClose:true,
                  message:ret.msg,
                  type:"info"
                })
              }
                
            }
          })
        },
        //页面加载中
        openFullScreen() {
          const loading = this.$loading({
          lock: true,
          text: "加载中（￣口￣）。。。",
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
          });
          // setTimeout(() => {
          if(this.loading==1){
            loading.close();
          }
          // }, 2000);
        },
        //返回
        goback(){
          this.$router.go(-1);
        },
      }
    }
  
  </script>
  
  <style scoped>
  </style>



// WEBPACK FOOTER //
// src/components/index/editforum.vue